import DevourClient from 'devour-client';

export const TYPE = 'press';

export default function (client: DevourClient) {
	client.define(
		TYPE,
		{
			description: '',
			createdAt: '',
			updatedAt: '',
			image: {},
			type: '',
			url: '',
		},
		{
			type: TYPE,
		}
	);

	return client;
}
